import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faChevronLeft, faPlus, faTimes, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Movie } from 'app/shared/models/class/movie/movie';
import { Push } from 'app/shared/models/class/notification/notification';
import { Rating } from 'app/shared/models/class/rating/rating';
import { RatingService } from 'app/shared/services/rating/rating.service';

@Component({
  selector: 'app-admin-ranting',
  templateUrl: './admin-ranting.component.html',
  styleUrls: ['./admin-ranting.component.scss'],

  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AdminRantingComponent implements OnInit {
  faChevronLeft = faChevronLeft;
  faPlus = faPlus;
  faTimes = faTimes;
  faSearch = faSearch;
  faTrashAlt = faTrashAlt;

  searchForm!: UntypedFormGroup;
  valueInput!: string
  rating: Rating[] = [];

  displayedColumnsMobile: string[] = ['title'];
  displayedColumnsDesktop: string[] = ['image', 'title', 'nbrOfRating', 'rating','disturbing'];
  columnsToDisplayWithExpand = [...this.displayedColumnsDesktop, 'expand'];
  listSubMovie: Movie | null | undefined;

  dataSource!: MatTableDataSource<Rating>;
  expandedElement!: Push | null;


  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  length!: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent!: PageEvent;

  color: ThemePalette = 'primary';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private ratingService: RatingService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  applyFilter(filtervalue: any): void {
    this.valueInput = filtervalue.value.trim().toLowerCase();
    this.dataSource.filter = filtervalue.value.trim().toLowerCase();
  }

  resetSearch(): void {
    this.f.keyword.reset();
    this.valueInput = '';
    this.applyFilter({ value: this.valueInput });
  }

  updateExpandedElement(element: any): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }


  private getRating(): void {
    this.ratingService.getRating().subscribe({
      next: rating => {
        // this.rating = rating.reverse();
        this.initTable(rating)
      }
    })
  }

  private initTable(push: Rating[]): void {
    this.dataSource = new MatTableDataSource<Rating>(push);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = push?.length;
  }

  private initComponent(): void {
    this.getRating();
  }


  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    })
  }

}
